import { render, staticRenderFns } from "./Stpf.vue?vue&type=template&id=0c7b72e6&scoped=true"
import script from "./Stpf.vue?vue&type=script&lang=js"
export * from "./Stpf.vue?vue&type=script&lang=js"
import style0 from "./Stpf.vue?vue&type=style&index=0&id=0c7b72e6&prod&scoped=cabteeb&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c7b72e6",
  null
  
)

export default component.exports